import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";
import { useSlidingLabelButton } from "./slidingLabelButton/useSlidingLabelButton";

type SlidingLabelButtonProps = {
  onClick: () => void;
  label: string;
  icon: IconDefinition;
};

export function SlidingLabelButton({
  onClick,
  label,
  icon,
}: SlidingLabelButtonProps) {
  const { labelContainerRef, labelContainerWidth, onMouseLeave, onMouseEnter } =
    useSlidingLabelButton();

  return (
    <button
      className="cursor-pointer flex flex-row items-center py-2 group gap-2"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={clsx(
          "font-medium",
          "text-font-secondary",
          "text-primary",
          "duration-200",
          "ease-in-out",
          "overflow-hidden",
          "shrink-0",
        )}
        ref={labelContainerRef}
        style={{
          width: labelContainerWidth,
        }}
      >
        <div>{label}</div>
      </div>
      <FontAwesomeIcon
        className="text-font-secondary text-lg group-hover:text-primary"
        icon={icon}
      />
    </button>
  );
}
